import script from "./PandoraSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraSearch.vue?vue&type=script&setup=true&lang=js"

import "./PandoraSearch.vue?vue&type=style&index=0&id=2a516f16&lang=css"

const __exports__ = script;

export default __exports__